module.exports = __webpack_public_path__ + "img/password.10ac18d2.svg";